module.exports = __webpack_public_path__ + "img/save.7cc2b43b.png";